module.exports = __webpack_public_path__ + "img/ban_18.a754f6a1.png";